import { render, staticRenderFns } from "./AltAccountTable.vue?vue&type=template&id=020a3472"
import script from "./AltAccountTable.vue?vue&type=script&lang=js"
export * from "./AltAccountTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports